import { render, staticRenderFns } from "./ParticipantAvatar.vue?vue&type=template&id=84d75454&scoped=true&"
import script from "./ParticipantAvatar.vue?vue&type=script&lang=js&"
export * from "./ParticipantAvatar.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantAvatar.vue?vue&type=style&index=0&id=84d75454&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d75454",
  null
  
)

export default component.exports